Monitoring.Views ||= {}

class Monitoring.Views.WeekdaysCalendarView extends Backbone.View
  template: JST["backbone/templates/monitoring/movistar_rules/weekdays_calendar"]

  initialize: (options) ->
    @interval = options.interval
    @weekdays = new AccountSettings.WorkCalendarWeekdayCollection()
    super

  fetchAndRender: =>
    if @interval.get('work_calendar_settings')
      models = _.map @interval.get('work_calendar_settings'), (weekday) =>
        new AccountSettings.WorkCalendarWeekday(weekday)
      @weekdays.set(models)
      @render()
    else
      # fetch calendar from account settings
      @weekdays.fetch().done () =>
        weekday_names = @weekdays.map (weekday) -> weekday.get('name')
        lacking_names = _.difference(
          ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"],
          weekday_names
        )
        @weekdays.add _.map(lacking_names, (name) -> {name: name})
        @render()

  buildTimeZoneSelector: =>
    new Monitoring.Views.TimeZoneSelectorView(
      (@weekdays.first())?.get('timezone')
    )

  render: =>
    @$el.html @template { @weekdays }
    @initializeTimePickers()
    @timeZoneSelectorView = @buildTimeZoneSelector()
    @$el.find('#work-calendar-time-zone-selector').html(
      @timeZoneSelectorView.render().el
    )
    @$el.find('#weekdays input').on 'change', (event) =>
      $target = $(event.target)
      @weekdays.get($target.attr('id')).set($target.attr('name'), $target.val())
    @$el.find('#weekdays .checkbox').on 'click', (event) =>
      $target = $(event.target).toggleClass('selected')
      @weekdays.get($target.attr('id')).set($target.data('attribute'), $target.hasClass('selected'))
    @

  initializeTimePickers: =>
    @$el.find('.timepicker').each ->
      $(this).modifiedwickedpicker
        twentyFour: true
        now: $(this).val() || '00:00'
        class: 'work-calendar-picker'
    @$el.find('.datepicker').each ->
      value = $(this).val()
      $(this).datepicker
        autoclose: true
        format: 'dd/mm/yyyy'
      $(this).datepicker 'setDate', value

  getSerialization: ->
    timezone = @timeZoneSelectorView.getSelectedTimeZone()
    @weekdays.each (weekday) -> weekday.set timezone: timezone
    JSON.stringify @weekdays
